const TITLE_PREFIXES = ['dr', 'mr', 'mrs', 'ms', 'miss', 'prof', 'sir', 'dame'];

/**
 * Returns initials from a display name, stripping common title prefixes (Dr, Mr, Mrs, etc.).
 * - Empty/null/whitespace → "?"
 * - Single part → first character
 * - Multiple parts (after stripping titles) → first char of first + first char of last
 */
export function getInitials(name: string | null | undefined): string {
  if (!name?.trim()) return '?';
  let parts = name.trim().split(/\s+/).filter(Boolean);
  const normalized = (s: string) => (s ?? '').toLowerCase().replace(/\.$/, '');
  while (parts.length > 1 && TITLE_PREFIXES.includes(normalized(parts[0] ?? ''))) {
    parts = parts.slice(1);
  }
  if (parts.length >= 2) {
    const first = parts[0]?.charAt(0) ?? '';
    const last = parts[parts.length - 1]?.charAt(0) ?? '';
    return `${first}${last}`.toUpperCase();
  }
  return (parts[0]?.charAt(0) ?? '?').toUpperCase();
}
